import { RouterItemType } from "@/app/index";
import { lazy } from "react";

const LayoutPageTermsAndConditions = lazy(() => import("./layout/index"));

export type LoaderDataTermsAndConditionsType = void;

export const routerPageTermsAndConditions: RouterItemType = {
  path: "/terms-and-conditions",
  authorize: false,
  element: <LayoutPageTermsAndConditions />,
};
